import { Grid } from "@mui/material";
import { DatePickerItem } from "components/Input/DatePicker/DatePickerItem";
import moment from "moment";
import { useEffect, useState } from "react";

const DateRangeFund = (props) => {

    const {
        NameStart,
        NameEnd,
        LabelStart,
        LabelEnd,
        IsMonthYearPicker = false,
        IsYearPicker = false,
        IsMonthPicker = false,
        required = false,
        isDisableYear = false,
        nYearMapper = null,
        nTrigger,
        onChange,
        nID,
    } = props;

    const [sMin, setSMin] = useState(null);
    const [sMax, setSMax] = useState(null);

    const handleChangeStart = (event, nID, type) => {
        if (onChange) {
            onChange(event, nID, type);
        }

        setSMin(event);
    }

    const handleChangeEnd = (event, nID, type) => {
        if (onChange) {
            onChange(event, nID, type);
        }
        setSMax(event);
    }

    useEffect(() => {
        setSMin(null);
        setSMax(null);
    }, [nTrigger])
    return (
        <Grid item xs={12} md={12} container spacing={1} direction="row" alignItems="start">
            <Grid item xs={5.8} className="flex-center">
                <DatePickerItem
                    name={NameStart}
                    label={LabelStart}
                    IsMonthYearPicker={IsMonthYearPicker}
                    IsYearPicker={IsYearPicker}
                    IsMonthPicker={IsMonthPicker}
                    required={required}
                    isDisableYear={isDisableYear}
                    nYearMapper={nYearMapper}
                    IsDisablePortal={true}
                    maxDate={sMax}
                    onChange={(e) => handleChangeStart(e, nID, "start")}
                />
            </Grid>
            <Grid item className="flex-center"> - </Grid>
            <Grid item xs={5.7} className="flex-center">
                <DatePickerItem
                    name={NameEnd}
                    label={LabelEnd}
                    IsMonthYearPicker={IsMonthYearPicker}
                    IsYearPicker={IsYearPicker}
                    IsMonthPicker={IsMonthPicker}
                    required={required}
                    IsDisablePortal={true}
                    isDisableYear={isDisableYear}
                    nYearMapper={nYearMapper}
                    minDate={sMin}
                    onChange={(e) => handleChangeEnd(e, nID, "end")}
                />
            </Grid>
        </Grid>
    )
}
export default DateRangeFund;